module.exports = __webpack_public_path__ + "img/tool2.17770f40.png";